import React from 'react';
import { Accordion } from 'react-bootstrap';
import { Faq } from '../HelpCenter.types';
import FAQComponentItem from './FAQComponentItem/FAQComponentItem';
import './HelpCenterFAQComponent.scss';

interface HelpCenterFAQComponent {
  title: string;
  icon: JSX.Element;
  faqs: Faq[];
}

function HelpCenterFAQComponent({ title, icon, faqs }: HelpCenterFAQComponent) {
  return (
    <div className="faq-component">
      <div className="faq-component-header">
        {React.cloneElement(icon, { className: 'faq-component-icon' }, null)}
        <div className="icon-subtext">{title}</div>
      </div>
      <div className="faq-component-body">
        <Accordion>
          {faqs.map((item, index) => (
            <FAQComponentItem accordionKey={index.toString()} key={item._key} question={item.question} answer={item.answer} />
          ))}
        </Accordion>
      </div>
    </div>
  );
}
export default HelpCenterFAQComponent;
